module.exports = __webpack_public_path__ + "static/media/ic_userGuide_sankarta.914423c0.png";